import { StickyHeader } from "../SimpleComponentVisualization";
import { ItemView } from "./LimitedListCells";
import LimitedListRow, { RowEditor } from "./LimitedListRow";
import { ListItem } from "./limitedListItems";

// A row to display, with the item's position in the unsorted data.
export type DisplayRow = { item: ListItem; index: number };

const LimitedListTable = ({
  rows,
  view,
  editing,
  onStartEdit,
  onDelete,
}: {
  rows: Array<DisplayRow>;
  view: ItemView;
  // The row being edited, by data index, with its editor.
  editing: { index: number; editor: RowEditor } | null;
  onStartEdit: (index: number, text: string) => void;
  onDelete: (index: number) => void;
}) => (
  <table className="table table-striped">
    <StickyHeader>
      <tr>
        {view.isEditMode && <th aria-label="Reorder" />}
        <th>Source</th>
        {/* A preferred width; the browser still shrinks it when the
            other columns need the space. */}
        <th style={view.isEditMode ? { width: "80%" } : undefined}>Content</th>
        <th>Moment</th>
      </tr>
    </StickyHeader>
    <tbody>
      {rows.map(({ item, index }) => (
        <LimitedListRow
          key={index}
          item={item}
          index={index}
          view={view}
          editor={editing?.index === index ? editing.editor : null}
          onStartEdit={(text) => onStartEdit(index, text)}
          onDelete={() => onDelete(index)}
        />
      ))}
    </tbody>
  </table>
);

export default LimitedListTable;
